
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
    Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
  }
  
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
    var obj = {
      title: 'Loyalty Points System',
      url:'#loyalty-points-system',
      target:0,
      badge: null,
      icon: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19"><path d="M9.92,19.5a.4.4,0,0,1-.28-.12A.4.4,0,0,1,9.53,19l.56-2.8a.39.39,0,0,1,.11-.2l6.16-6.16a1.19,1.19,0,0,1,1.68,0L19.15,11a1.19,1.19,0,0,1,0,1.68L13,18.82a.39.39,0,0,1-.2.11l-2.8.56H9.92m.92-3-.42,2.1,2.1-.42,6.07-6.07a.4.4,0,0,0,0-.56l-1.12-1.12a.4.4,0,0,0-.56,0ZM12,2.87H10.79v-.4a.4.4,0,0,0-.4-.4H9.17a2,2,0,0,0-3.88,0H4.06a.4.4,0,0,0-.4.4v.4H2.48a2,2,0,0,0-2,2V15.15a2,2,0,0,0,2,2H8a.4.4,0,0,0,0-.79H2.48a1.19,1.19,0,0,1-1.19-1.19V4.85A1.19,1.19,0,0,1,2.48,3.67H3.67v.4A1.19,1.19,0,0,0,4.85,5.25H9.6a1.19,1.19,0,0,0,1.19-1.19v-.4H12a1.19,1.19,0,0,1,1.19,1.19V9.6a.4.4,0,1,0,.79,0V4.85a2,2,0,0,0-2-2M10,4.06a.4.4,0,0,1-.4.4H4.85a.4.4,0,0,1-.4-.4V2.87H5.65a.4.4,0,0,0,.4-.4,1.19,1.19,0,0,1,2.38,0,.4.4,0,0,0,.4.4H10Zm1.19,3.56H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79m0,2.38H3.27a.4.4,0,0,1,0-.79h7.92a.4.4,0,0,1,0,.79" transform="translate(-0.5 -0.5)"></path></svg>',
      isShow: 1,
      loader:null,
      body_html: '<div id="flits-loyality-div"></div>'
    }
    settings.navs.splice(5, 0, obj);
  });

  function flitsCustomIntregation(){
    var lion_integrated_page = Flits(".flits-custom-lion-page").children();
    var lion_integrated_page_mobile = Flits(".flits-custom-lion-page-mobile").children();
    Flits("#flits-loyality-div").append(lion_integrated_page);
    Flits("#flits_mobile_tab_loyality-points-system #flits-loyality-div").append(lion_integrated_page_mobile);
    
    Flits(".flits-custom-lion-page").remove();
    Flits(".flits-custom-lion-page-mobile").remove();
  }

  Flits(document).on('Flits:AccountPage:Loaded', function(event){ 
    setInterval(function(){
    flitsCustomIntregation();
    },1500)
        
  });

  window.Flits.fn.extend({
    appendSocialLoginDivAdded: function (socialLoginBtnGroup, isTrue) {
      var settings = Flits.SocialLogin.settings;
      this.filter(':not([data-flits="social-login-added"])').each(function (index, el) {
        el = Flits(el);
        if (isTrue) {
          if (el.css("display") == "none") {
            return;
          }
        }
        if (typeof el[0].addEventListener != "function") {
          return;
        }
        var parent = el.parent();
        var cloneNode = socialLoginBtnGroup.clone(true);
        parent.append(cloneNode);
        el.attr("data-flits", "social-login-added");
        parent.attr("data-flits", "social-login-parent");
        settings.automaticAppendDivFunction.apply(this, [el, parent, cloneNode]);
        Flits.dispatchEvent("Flits:SocialLoginAutomaticCode:Loaded", { el: el, parent: parent, cloneNode: cloneNode });
      });
      return this;
    }
  })

  function buttonAppendButtons() {
    let selector = Flits.SocialLogin.settings.domSelector;
    let selectorLength = Flits.SocialLogin.settings.domSelector.length;
    let items = Flits.SocialLogin.settings.buttonConfig;
    let socialLoginBtnGroup = Flits("<div />");
    socialLoginBtnGroup.addClass("flits-social-login-btn-grp");
    let socialLoginErrorDiv = Flits("<div />");
    socialLoginErrorDiv.addClass("flits-social-login-error");
    Flits.each(items, function (index, item) {
      if (Flits.Metafields[item.metafieldName] && item.isDisplay) {
        let btnClone = Flits("#flits-social-login-btn-template").clone();
        btnClone.removeAttr("id");
        let hrefAttr = btnClone
        .attr("data-href")
        .replace("proxy_name", Flits.proxy_name)
        .replace("app_id", Flits.app_id)
        .replace("shop_id", Flits.shop_id)
        .replace("shop_token", Flits.token)
        .replace("login_type", item.login_type);
        btnClone.attr("href", hrefAttr);
        btnClone.attr("data-flits-provider", index);
        btnClone.removeAttr("data-href");
        btnClone.addClass(item.btn_class);
        btnClone.css("order", item.order);
        Flits(btnClone).find(".flits-social-login-btn-img").html(item.icon_img);
        Flits(btnClone).find(".flits-social-login-btn-text").html(item.login_name);
        socialLoginBtnGroup.append(btnClone);
      }
    });
    let code = Flits("<div />");
    code.addClass("flits-social-login-container");
    code.append(socialLoginBtnGroup);
    code.append(socialLoginErrorDiv);
    for (i = 0; Flits.SocialLogin.settings.domSelector.length > i; i++) {
      Flits.SocialLogin.settings.domSelector;
      Flits(Flits.SocialLogin.settings.domSelector[i][0]).appendSocialLoginDivAdded(code, Flits.SocialLogin.settings.domSelector[i][1]);
    }
  };

  Flits(window).on('load', function(event){
    buttonAppendButtons();        
  });
	
   Flits(document).on('Flits:SocialLoginAutomaticCode:Loaded', function(event){
    var data = event.detail;
    var el = data.el;
    var parent = data.parent; // parent
    var cloneNode = data.cloneNode; // cloned social login div
     Flits(event.detail.cloneNode).insertAfter(event.detail.el[0].children[2]);
     if (Flits(parent).attr("class") == "container"){
        el.append(cloneNode);
       Flits( "<div id='flits-social-header'><span>Or login with social below</span></div>" ).insertBefore(event.detail.cloneNode);
     } else {
     Flits( "<div id='flits-social-header'><span>Or login with social below</span></div>" ).insertBefore(event.detail.cloneNode);
     }
     
  });

   window.addEventListener('FlitsMsg91Loaded', function(){
       setTimeout(function(){
         let otpSocial = document.querySelector('#flits-otp-social-login-container');
         let registerDiv = document.createElement('div');
         let registerLink = `<p class="flits-otp-register-link">New customer? <a href="/account/register" class="link link--accented">Create your account</a></p>`
         registerDiv.innerHTML = registerLink;
        if(otpSocial){
          //Flits('#flits-social-header').insertBefore(otpSocial);
          otpSocial.appendChild(document.querySelector('#flits-social-header'));
          //Flits('.flits-social-login-container').insertBefore(otpSocial);
          otpSocial.appendChild(document.querySelector('.flits-social-login-container'));
          if(window.location.pathname != '/account/register'){
           otpSocial.appendChild(registerDiv); 
          }
        }
       }, 2000);
     });
  
  
  
//     Flits(document).on('Flits:SocialLoginAutomaticCode:Loaded', function(event){  
//     var data = event.detail;
//     Flits(event.detail.cloneNode).insertAfter(event.detail.el[0].children[2]);
//     Flits('<div id="flits-social-header"><h3>Login With Social or</h3></div>').insertAfter(event.detail.cloneNode);
//   });

  Flits.extend({
    redirectToCheckout: async function (parameters) {
      parameters = parameters || {};
      var form = Flits(Flits.StoreCreditCart.settings.checkoutFormSelectors.join(','));
      if (form.length <= 0) {
        location.href = "/checkout?" + Flits.param(parameters);   
        // location.href = location.origin+"/discount/"+parameters?.discount+"?redirect=/checkout";
        return true;
      }
      fetch(`/discount/${parameters?.discount}`)
        .then(function() {
            var form_action = form.attr("action");
            var form_action_data = Flits.parseURL(form_action);
      
            Flits.each(parameters, function (index, item) {
              var existing = form.find("[name='" + index + "']");
              if (existing.length <= 0) {
                form.append("<input type='hidden' name='" + index + "' value='" + item + "'>");
              } else {
                existing.val(item);
              }
              if (form_action_data.searchObject[index]) {
                form_action = form_action.replace(index + '=' + form_action_data.searchObject[index], item);
              } else {
                form_action += (form_action.indexOf('?') !== -1 ? "&" : "?") + index + "=" + item;
              }
            });
            form.append("<input type='hidden' name='checkout' value='true'>");
            form.attr("action", form_action);
            form.trigger('submit', [{ flitsFormSubmitted: true }]);
      });
    }
  })
}(Flits));
